export function moveElementChildren(currentParent: Element, newParent: Element): void {
    while (currentParent.firstChild !== null) {
        newParent.appendChild(currentParent.firstChild);
    }
}
